const COMPANY_UID_KEY = 'sigmund_company_uid';
const AUTH_TOKEN_KEY = 'sigmund_auth_token';

function fromEnv(key, fallback = '') {
  const value = process.env[key];
  if (typeof value === 'string' && value.trim()) return value.trim();
  return fallback;
}

export function getInitialCompanyUid() {
  const fromStorage = localStorage.getItem(COMPANY_UID_KEY);
  if (fromStorage && fromStorage.trim()) return fromStorage.trim();
  return fromEnv('REACT_APP_SIGMUND_DEFAULT_COMPANY_UID', '');
}

export function saveCompanyUid(value) {
  localStorage.setItem(COMPANY_UID_KEY, value.trim());
}

export function getInitialAuthToken() {
  const fromStorage = localStorage.getItem(AUTH_TOKEN_KEY);
  if (fromStorage && fromStorage.trim()) return fromStorage.trim();
  return fromEnv('REACT_APP_SIGMUND_DEFAULT_AUTH_TOKEN', '');
}

export function saveAuthToken(value) {
  localStorage.setItem(AUTH_TOKEN_KEY, value.trim());
}
